const SubjectIcon = () => {
    return <img src={process.env.PUBLIC_URL + '/style/img/btn-icon/ico-apply.png'} />;
};

export default SubjectIcon;
